'use client';

import { useSuspenseQuery } from '@apollo/client';
import {
    UserFeaturesFragmentFragment,
    GET_USER_FEATURE_FLAGS,
    USER_FEATURES_FRAGMENT,
    getFragmentData,
} from '@deltasierra/frontend-graphql-core';

export function useUserFeatures(): {
    userFeatureFlags: UserFeaturesFragmentFragment | null;
} {
    const { data } = useSuspenseQuery(GET_USER_FEATURE_FLAGS);

    return { userFeatureFlags: getFragmentData(USER_FEATURES_FRAGMENT, data.me.features) };
}
